<template>
    <button
        type="button"
        class="crm-card"
        :class="{ active }"
        @click="$emit('select')"
    >
        <span
            v-if="tag"
            class="crm-tag"
            :class="tagClass"
        >{{ tag }}</span>
        <img
            v-if="avatarImg"
            class="card-image"
            :src="avatarImg"
            alt=""
        />
        <div v-else class="crm-fallback">
            <span
                class="crm-fallback-symbol"
                :style="{ backgroundColor: computedConnectorColor }"
            >
                {{ computedConnectorSymbol }}
            </span>
            <span class="crm-fallback-name">{{ displayName }}</span>
        </div>
    </button>
</template>

<script>
import { getCurrentInstance, ref, computed } from 'vue'

export default {
    name: 'ConnectorSettingsCard',
    props: {
        connector: {
            type: Object,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
        tag: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const root = getCurrentInstance().proxy
        const store = root.$store
        const avatarImg = ref(null)
        try {
            avatarImg.value = require('@/assets/img/onBoarding/CRMImages/' + props.connector.type + '.png')
        } catch (e) {
            avatarImg.value = null
        }

        const avatar = computed(() => store.getters.connectorAvatarByType(props.connector.type) || {})
        const computedConnectorSymbol = computed(() => avatar.value.symbol || '')
        const computedConnectorColor = computed(() => avatar.value.color || '#EEF0FF')
        const displayName = computed(
            () => avatar.value.name || props.connector.name || props.connector.type,
        )
        const tagClass = computed(() => {
            if (props.tag === 'API') return 'api'
            if (props.tag === 'Маркет') return 'auto'
            return ''
        })

        return {
            avatarImg,
            computedConnectorSymbol,
            computedConnectorColor,
            displayName,
            tagClass,
        }
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.crm-card
    height: 108px
    border: 1.5px solid #DDE3EF
    background: #fff
    border-radius: 16px
    padding: 14px
    display: flex
    align-items: center
    justify-content: center
    position: relative
    transition: 0.18s ease
    cursor: pointer
    user-select: none
    width: 100%
    min-width: 0
    overflow: hidden
    box-sizing: border-box
    font: inherit
    appearance: none
    outline: none
    &:hover
        border-color: rgba(82, 90, 213, 0.55)
        box-shadow: 0 10px 28px rgba(82, 90, 213, 0.10)
        transform: translateY(-1px)
    &.active
        border-color: $main-new
        box-shadow: 0 0 0 4px rgba(82, 90, 213, 0.10), 0 16px 34px rgba(82, 90, 213, 0.16)

.crm-tag
    position: absolute
    top: 10px
    right: 10px
    font-size: 9px
    font-weight: 900
    text-transform: uppercase
    letter-spacing: 0.06em
    border-radius: 999px
    padding: 4px 7px
    background: #F2F4F8
    color: $muted-new
    line-height: 1
    z-index: 1
    &.api
        background: $bcg-card-new
        color: $main-new
    &.auto
        background: #E9FFF4
        color: #12945D

.card-image
    display: block
    width: auto
    height: auto
    max-width: 100%
    max-height: 56px
    object-fit: contain
    object-position: center

.crm-fallback
    display: flex
    flex-direction: column
    align-items: center
    gap: 8px
    max-width: 100%
    min-width: 0

.crm-fallback-symbol
    border-radius: 100%
    width: 40px
    height: 40px
    display: flex
    align-items: center
    justify-content: center
    font-size: 12px
    font-weight: 800
    color: $dark-new
    flex: 0 0 auto

.crm-fallback-name
    font-size: 13px
    font-weight: 800
    color: $dark-new
    text-align: center
    letter-spacing: -0.02em
    max-width: 100%
    overflow: hidden
    text-overflow: ellipsis

@media (max-width: 700px)
    .crm-card
        height: 94px
        padding: 12px 10px

    .card-image
        max-height: 40px
        max-width: calc(100% - 4px)

    .crm-fallback-name
        font-size: 11px
</style>
